<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Clave"
      label="Clave"
      type="text"
      v-model="formData.Clave"
      :required="true"
      :maxlength="50"
      :disabled="isEditing"
      helpText="Clave única de la serie"
    />
    
    <!-- Campo EmpresaId oculto - se captura automáticamente -->
    <input type="hidden" v-model="formData.EmpresaId" />
    
    <FormField
      id="ObjetoId"
      label="ID de Objeto"
      type="number"
      v-model="formData.ObjetoId"
      :required="true"
      helpText="ID del objeto asociado"
    />
    
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="100"
      helpText="Nombre de la serie (máximo 100 caracteres)"
    />
    
    <FormField
      id="SiguienteFolio"
      label="Siguiente Folio"
      type="number"
      v-model="formData.SiguienteFolio"
      :min="0"
      helpText="Siguiente número de folio"
    />
    
    <FormField
      id="ClaveErp"
      label="Clave ERP"
      type="text"
      v-model="formData.ClaveErp"
      :maxlength="50"
      helpText="Clave en el sistema ERP"
    />
    
    <FormField
      id="EsActivo"
      label="Estado"
      type="checkbox"
      v-model="formData.EsActivo"
      checkboxLabel="Serie activa"
      helpText="Indica si la serie está activa en el sistema"
    />
    
    <FormField
      id="TipoDocumento"
      label="Tipo de Documento"
      type="text"
      v-model="formData.TipoDocumento"
      :maxlength="50"
      helpText="Tipo de documento de la serie"
    />
    
    <FormField
      id="Serie"
      label="Serie"
      type="text"
      v-model="formData.Serie"
      :maxlength="50"
      helpText="Serie del documento"
    />
    
    <FormField
      id="FolioInicial"
      label="Folio Inicial"
      type="number"
      v-model="formData.FolioInicial"
      :min="0"
      helpText="Folio inicial de la serie"
    />
    
    <FormField
      id="FolioFinal"
      label="Folio Final"
      type="number"
      v-model="formData.FolioFinal"
      :min="0"
      helpText="Folio final de la serie"
    />
    
    <FormField
      id="Estatus"
      label="Estatus"
      type="text"
      v-model="formData.Estatus"
      :maxlength="50"
      helpText="Estatus de la serie"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatSerieForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    serie: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: null,
        ObjetoId: null,
        Nombre: '',
        SiguienteFolio: 0,
        ClaveErp: '',
        EsActivo: true,
        TipoDocumento: '',
        Serie: '',
        FolioInicial: 0,
        FolioFinal: 0,
        Estatus: ''
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.serie }
    };
  },
  watch: {
    serie: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      // Convertir números si existen
      if (dataToSubmit.SiguienteFolio !== null && dataToSubmit.SiguienteFolio !== '') {
        dataToSubmit.SiguienteFolio = parseInt(dataToSubmit.SiguienteFolio);
      } else {
        dataToSubmit.SiguienteFolio = 0;
      }
      
      if (dataToSubmit.FolioInicial !== null && dataToSubmit.FolioInicial !== '') {
        dataToSubmit.FolioInicial = parseInt(dataToSubmit.FolioInicial);
      } else {
        dataToSubmit.FolioInicial = 0;
      }
      
      if (dataToSubmit.FolioFinal !== null && dataToSubmit.FolioFinal !== '') {
        dataToSubmit.FolioFinal = parseInt(dataToSubmit.FolioFinal);
      } else {
        dataToSubmit.FolioFinal = 0;
      }
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>
